import { render, staticRenderFns } from "./PlateTitle.vue?vue&type=template&id=f4a2055e&scoped=true"
import script from "./PlateTitle.vue?vue&type=script&lang=js"
export * from "./PlateTitle.vue?vue&type=script&lang=js"
import style0 from "./PlateTitle.vue?vue&type=style&index=0&id=f4a2055e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a2055e",
  null
  
)

export default component.exports